<template>
    <v-layout data-app="true">
        <companyProfileWrap :user="user" :company_page="$route.params.id ? other_company : company_info" />
    </v-layout>
</template>

<script>
import companyProfileWrap from '@/components/view_blocks/Company_profile/Company_profile_wrap';
import {mapGetters, mapMutations, mapActions}          from 'vuex';

export default {
  components: {
    companyProfileWrap,
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('company_profile/info', [
      'company_info',
    ]),
    ...mapGetters('company_profile', [
      'other_company',
    ]),
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.get_other_company(this.$route.params.id);
    } else {
      await this.replace_company();
      if (localStorage.user != 'undefined') {
        this.REPLACE_USER_PROFILE(JSON.parse(localStorage.getItem('user')));
      }
    }
  },
  methods: {
    ...mapActions('company_profile', [
      'get_other_company',
    ]),
    ...mapActions('company_profile/info', [
      'replace_company',
    ]),
    ...mapMutations('profile/user', [
      'REPLACE_USER_PROFILE',
    ]),
  },

};
</script>

